/*
 * 订单确认
 * */
import request from "@utils/request";

export function getHasStore(){
  return request.get('has_store');
}

export function searchCard(number){
  return request.get('bond/getCardList?number=' + number);
}

export function saveCard(data){
  return request.post('bond/saveExchangeInfo', data);
}

export function checkPwd(data){
  return request.post('bond/passwordVerification', data);
}

export function saveCardScore(data){
  return request.post('bond/addScore', data);
}
